import m, {Vnode} from "mithril";
import {ImageItem} from "../../../../model/items/imageItem";
import {LabelItem} from "../../../../model/items/labelItem";
import Cell from "../../../../model/form/cell";
import Image from "../../../shared/components/Image/Image";
import LabelCell from "../../../shared/components/FormCell/LabelCell";
import {SliderItem} from "../../../../model/items/slider";
import KandidatiFinale from "../KandidatiFinale";

type TKandidatiRow = {
    image: ImageItem,
    name: LabelItem,
    description: LabelItem,
    slider: SliderItem
};

export default class KandidatFinale {

    public static parseRow(row: Cell[]): TKandidatiRow {
        if (row?.length < 4) {
            throw new Error("Expect row includes 4 or more items.")
        }
        const image = row[0]?.getItems()[0];
        const name = row[1]?.getItems()[0];
        const description = row[2]?.getItems()[0];
        const slider = row[3]?.getItems()[0];

        if (image instanceof ImageItem && name instanceof LabelItem && description instanceof LabelItem && slider instanceof SliderItem) {
            return {image, name, description, slider};
        }
        throw new Error("Expects row: Image, Label, Label, Slider, ...any.")
    }

    private readonly image: Image;
    private readonly name: LabelCell;
    private readonly description: LabelCell;

    constructor(
        private readonly row: TKandidatiRow,
        private readonly kandidati: KandidatiFinale,
    ) {
        this.image = new Image(row.image);
        this.name = new LabelCell(row.name);
        this.description = new LabelCell(row.description);
    }

    public get slider(): SliderItem {
        return this.row.slider;
    }

    public getValue(): number {
        return Number(this.row.slider.getVariable() ?? this.row.slider.initialValue ?? 0);
    }

    private getFormattedValue(): string {
        const options: Intl.NumberFormatOptions = {
            minimumFractionDigits: this.kandidati.decimalPlaces,
            maximumFractionDigits: this.kandidati.decimalPlaces,
        };
        return (this.getValue().toLocaleString(undefined, options)+' '+this.kandidati.unit).trim();
    }

    public view(): Vnode {
        const isSet = this.row.slider.getVariable() !== undefined;
        const looser = isSet && this.getValue() < this.slider.range.max / 2;
        const winner = isSet && this.getValue() > this.slider.range.max / 2;
        return m('.kandidat'+(looser?'.looser':'')+(winner?'.winner':''), {}, [
            m(this.name),
            m('.kandidat-image', {}, [
                m(this.image),
                m(this.description),
            ]),
            m('.kandidat-value'+(isSet?'.has-value':''), {}, this.getFormattedValue())
        ]);
    }
}